import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { DETAIL_TEXT, PRIMARY_COLOR, PRIMARY_COLOR_8, SECONDARY_TEXT } from '../../../../appearance/Colors';

const { FAQ_ITEMS } = require('../../../../seo/faqItems');

const propTypes = {
    ...SectionTilesProps.types
};

const defaultProps = {
    ...SectionTilesProps.defaults
};

const sectionHeader = {
    title: 'Frequently Asked Questions',
    paragraph: 'Everything you need to know about Luckynote'
};

const FAQ = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    pushLeft,
    ...props
}) => {
    const [openIndex, setOpenIndex] = useState(null);
    const [heights, setHeights] = useState({});
    const answerRefs = useRef({});
    const observers = useRef({});

    useEffect(() => {
        // Setup ResizeObserver for each answer
        FAQ_ITEMS.forEach((_, index) => {
            if (answerRefs.current[index]) {
                observers.current[index] = new ResizeObserver(entries => {
                    for (let entry of entries) {
                        setHeights(prev => ({
                            ...prev,
                            [index]: entry.contentRect.height
                        }));
                    }
                });
                observers.current[index].observe(answerRefs.current[index]);
            }
        });

        // Cleanup observers
        return () => {
            Object.values(observers.current).forEach(observer => observer.disconnect());
        };
    }, []);

    const outerClasses = classNames(
        'faq section',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'faq-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    return (
        <section {...props} className={outerClasses} id="faq">
            <div className="container">
                <div className={innerClasses}>
                    <SectionHeader data={sectionHeader} className="center-content" />
                    <div className="faq-content">
                        {FAQ_ITEMS.map((item, index) => (
                            <div
                                key={index}
                                className="faq-item"
                                style={{
                                    borderBottom: '1px solid rgba(20, 17, 15, 0.1)',
                                    marginBottom: 24
                                }}
                            >
                                <div
                                    className="faq-question"
                                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        paddingBottom: 16
                                    }}
                                >
                                    <h4 style={{ 
                                        margin: 0,
                                        fontSize: 18,
                                        fontWeight: '500',
                                        color: openIndex === index ? PRIMARY_COLOR : 'inherit'
                                    }}>
                                        {item.question}
                                    </h4>
                                    {openIndex === index ? (
                                        <FiChevronUp size={24} color={PRIMARY_COLOR} />
                                    ) : (
                                        <FiChevronDown size={24} />
                                    )}
                                </div>
                                <div
                                    className="faq-answer-wrapper"
                                    style={{
                                        height: openIndex === index ? `${heights[index] + 16}px` : '0',
                                        overflow: 'hidden',
                                        transition: 'height 0.25s ease-out'
                                    }}
                                >
                                    <div
                                        className="faq-answer"
                                        ref={el => answerRefs.current[index] = el}
                                        style={{
                                            opacity: openIndex === index ? 1 : 0,
                                            transition: 'opacity 0.15s ease-out',
                                            fontSize: 16,
                                            lineHeight: '28px',
                                            color: PRIMARY_COLOR_8,
                                            paddingBottom: 16,
                                            willChange: 'opacity'
                                        }}
                                    >
                                        {item.answer}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

FAQ.propTypes = propTypes;
FAQ.defaultProps = defaultProps;

export default FAQ; 
